import React, { useState } from "react";

import calendar from "../../../assets/images/calendar.svg";

function InputComponent({
  config,
  options = {},
  value,
  onChange,
  onSelect,
  customWidth,
}) {
  const { label, type, placeholder, options: optionsKey, required } = config;
  const selectOptions =
    optionsKey && options[optionsKey] ? options[optionsKey] : optionsKey;

  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleInputChange = (e) => {
    if (onChange) onChange(e);
    if (type === "text" && optionsKey) {
      setShowSuggestions(true);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    onChange({ target: { value: suggestion.value } });
    onSelect && onSelect(suggestion);
    setShowSuggestions(false);
  };

  const handleInputBlur = () => {
    setTimeout(() => setShowSuggestions(false), 200);
  };

  const handleInputFocus = () => {
    setShowSuggestions(true);
  };

  const handleSelectChange = (e) => {
    const selectedOption = selectOptions.find(
      (option) => option.value === e.target.value
    );
    if (onChange) onChange(e);
    onSelect && onSelect(selectedOption);
  };

  const handleToggleChange = () => {
    if (onChange) {
      const newValue = !value;
      onChange({
        target: {
          checked: newValue,
          value: newValue,
          type: "checkbox",
        },
      });
    }
  };

  const handleKeyDown = (e) => {
    e.preventDefault();
  };

  const shouldShowNoResults =
    value &&
    typeof value === "string" &&
    value.trim() !== "" &&
    selectOptions &&
    selectOptions.length === 0;

  return (
    <>
      {type === "text" && (
        <div className={`input-text-wrapper ${customWidth ? customWidth : ""}`}>
          <label className="input-text-label">
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </label>
          <input
            className="input-text-input"
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />
          {showSuggestions && selectOptions && (
            <div
              className="suggestions-list"
              onMouseDown={(e) => e.preventDefault()}
            >
              {shouldShowNoResults ? (
                <div className="suggestion-item">No results found</div>
              ) : (
                selectOptions.map((option, index) => (
                  <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => handleSuggestionClick(option)}
                  >
                    {option.label}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      )}
      {type === "textarea" && (
        <div className="input-textArea-wrapper">
          <label className="input-text-label">
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </label>
          <textarea
            className="input-textArea-input"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        </div>
      )}
      {type === "select" && (
        <div className={`input-text-wrapper ${customWidth ? customWidth : ""}`}>
          <label className="input-text-label">
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </label>
          <select
            className="input-text-input"
            onChange={handleSelectChange}
            value={value}
          >
            <option value="" disabled hidden>
              {placeholder}
            </option>
            {selectOptions.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {type === "date" && (
        <div className="input-text-wrapper">
          <label className="input-text-label">
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </label>
          <div className="custom-date-wrapper-event-form">
            <input
              className="custom-date-input"
              type="date"
              placeholder={placeholder}
              value={value}
              onChange={handleInputChange}
              onFocus={(e) => e.target.showPicker()}
              onKeyDown={handleKeyDown}
              min={new Date().toISOString().slice(0, 10)}
              max="9999-12-31"
            />
            <img
              src={calendar}
              alt="Calendar Icon"
              className="custom-date-icon"
              onClick={(e) => {
                const input = e.target.previousSibling;
                input.showPicker();
              }}
            />
          </div>
        </div>
      )}
      {type === "time" && (
        <div className="input-text-wrapper">
          <label className="input-text-label">
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </label>
          <div className="input-time-wrapper">
            <input
              type="time"
              className="input-time-input1"
              value={value}
              onChange={onChange}
              onFocus={(e) => e.target.showPicker()}
            />
            <select
              className="input-time-input2"
              onChange={onChange}
              value={value}
            >
              <option value="IST">IST</option>
            </select>
          </div>
        </div>
      )}
      {type === "toggle" && (
        <div className="toggleDiv">
          <label className="input-text-label">
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </label>
          <div className="custom-toggle-wrapper" onClick={handleToggleChange}>
            <input
              type="checkbox"
              className="toggle-input"
              checked={value || false}
              readOnly
            />
            <label className="toggle-label">
              <span
                className="toggle-text yes"
                style={{ opacity: value ? 1 : 0 }}
              >
                Yes
              </span>
              <span
                className="toggle-text no"
                style={{ opacity: value ? 0 : 1 }}
              >
                No
              </span>
              <span className="toggle-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="22"
                  viewBox="0 0 21 22"
                  fill="none"
                >
                  <circle cx="10.5" cy="10.5645" r="10.5" fill="#2F80ED" />
                </svg>
              </span>
            </label>
          </div>
          <style jsx>{`
            .custom-toggle-wrapper {
              position: relative;
              display: inline-block;
              cursor: pointer;
            }

            .toggle-input {
              display: none;
            }

            .toggle-label {
              display: inline-block;
              width: 60px;
              height: 26px;
              border-radius: 22px;
              border: 2px solid #2f80ed;
              background: #fff;
              position: relative;
              transition: all 0.3s ease;
            }

            .toggle-text {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              font-size: 10px;
              font-weight: 500;
              color: #000;
              transition: opacity 0.3s ease;
              pointer-events: none;
            }

            .toggle-text.yes {
              left: 8px;
            }

            .toggle-text.no {
              right: 8px;
            }

            .toggle-circle {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              transition: all 0.3s ease;
              left: ${value ? "35px" : "2px"};
              pointer-events: none;
            }
          `}</style>
        </div>
      )}
    </>
  );
}

export default InputComponent;
